import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'map',
    loadChildren: () => import('./pages/map/map.module').then(m => m.MapPageModule)
  },
  {
    path: 'avis',
    loadChildren: () => import('./pages/avis/avis.module').then(m => m.AvisPageModule)
  },
  {
    path: 'assainissements',
    loadChildren: () => import('./pages/assainissement/assainissement.module').then(m => m.AssainissementPageModule)
  },
  {
    path: 'urbaine',
    loadChildren: () => import('./pages/urbaine/urbaine.module').then(m => m.UrbainePageModule)
  },
  {
    path: 'stats',
    loadChildren: () => import('./pages/stats/stats.module').then(m => m.StatsPageModule)
  },
  {
    path: 'users',
    loadChildren: () => import('./pages/users/users.module').then(m => m.UsersPageModule)
  },
  {
    path: 'equipes',
    loadChildren: () => import('./pages/equipes/equipes.module').then(m => m.EquipesPageModule)
  },
  {
    path: 'communes',
    loadChildren: () => import('./pages/communes/communes.module').then(m => m.CommunesPageModule)
  },
  {
    path: 'agglomerations',
    loadChildren: () => import('./pages/agglos/agglos.module').then(m => m.AgglosPageModule)
  },
  {
    path: 'climat',
    loadChildren: () => import('./pages/climat/climat.module').then(m => m.ClimatPageModule)
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./pages/folder/folder.module').then(m => m.FolderPageModule)
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/public/welcome/welcome.module').then(m => m.WelcomePageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
